
  const settlement = {
    path: "/settlement",
    name: "Settlement",
    component: () => import(/* webpackChunkName: "settlement" */ "@/components/settlement/SettlementReview.vue"),
    meta: { authorize: ['Factory - Supervisor'], requiresAuth: true }
  };

export default settlement;